module.exports = __webpack_public_path__ + "img/Iconos_11.6f358ff6.png";